export default "__VITE_ASSET__KDJn4_x___"